<tt-page *ngIf="!!itemsListReportLayouts">
    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListReportLayouts"></tt-list>

    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button-goto [ttText]="'acreportlayouts_new'" (ttClick)="goToFunc('acreportlayout')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <im-list-directive class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListReportLayouts" badge="" ltype="" design-var="s12t0"></im-list-directive>

    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button class="col-xs-12 sp-0" tt-text="acreportlayouts_new" tt-click="vm.goToFunc('acreportlayout')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
    </tt-card>
</tt-page>-->
